<template>
    <div
        class="relative max-w-full"
        ref="dropdown"
        :class="isSmall ? 'h-8' : 'h-11'"
    >
        <div
            class="
                absolute
                h-full
                w-full
                left-0
                top-0
                bg-transparent
                z-10
                cursor-pointer
            "
            @click="state.isActive = !state.isActive"
        ></div>
        <div
            class="
                relativ
                w-full
                h-full
                transition-all
                border
                rounded-xl
                cursor-pointer
            "
            :class="[
                isSmall ? 'border-none' : '',
                state.isActive
                    ? `border-black`
                    : `border-grey-light hover:border-black`,
            ]"
        >
            <input
                ref="input"
                disabled
                class="
                    w-full
                    pr-7
                    select-none
                    transition-colors
                    bg-transparent
                    border-none
                    pl-4
                    h-full
                    cursor-pointer
                    overflow-hidden overflow-ellipsis
                "
                :name="name"
                :class="[
                    state.isActive || acitveItemsString.length > 0
                        ? `text-${activeColor}`
                        : `text-${defaultColor}`,
                ]"
                :id="id"
                :value="acitveItemsString"
            />
            <label
                :for="id"
                class="
                    absolute
                    transition-all
                    cursor-pointer
                    left-3
                    px-1
                "
                :class="[
                    isSmall
                        ? acitveItemsString.length > 0
                            ? 'opacity-0'
                            : 'top-1 opacity-100'
                        : acitveItemsString.length > 0
                        ? '-top-3 text-sm'
                        : 'top-2 text-md',
                    ,
                    `text-${activeColor}`,
                    labelClass,
                ]"
                >{{ label }}</label
            >
            <arrow-icon
                class="absolute right-3 transition-all"
                :class="[
                    isSmall ? 'top-4' : 'top-5',
                    { 'trans-r-180': state.isActive },
                ]"
                :fillClass="
                    state.isActive || acitveItemsString.length > 0
                        ? `fill-${activeColor}`
                        : `fill-${defaultColor}`
                "
            />
        </div>
        <height-transition>
            <div
                class="
                    transition-all
                    absolute
                    flex flex-col
                    left-0
                    top-12
                    py-1
                    w-full
                    z-50
                    rounded-xl
                    overflow-hidden
                "
                :class="[
                    state.isActive
                        ? 'border active max-h-64 ' + background
                        : 'max-h-0',
                    'border-' + activeColor,
                ]"
            >
                <div class="w-full px-1 h-16 py-2" v-if="isSearch">
                    <input-text
                        :id="'filter-text'"
                        :label="$t('filter')"
                        v-model="state.filterText"
                        :labelClass="background"
                        class="w-full"
                    />
                </div>
                <div
                    class="scrollbar overflow-auto"
                    :class="isSearch ? 'max-h-48' : 'max-h-64'"
                >
                    <div
                        v-for="(option, index) in filteredOptions"
                        :key="index"
                        class="
                            flex flex-row
                            pl-1
                            pr-3
                            cursor-pointer
                            justify-between
                            items-center
                            transition-colors
                            h-10
                            hover:bg-opacity-10
                        "
                        :class="'hover:bg-' + activeColor"
                        @click.stop="
                            $emit('changeItem', option);
                            REMOVE_ERROR_ID();
                        "
                    >
                        <div
                            class="w-full-15 flex flex-row p-1"
                            v-if="nameColumn"
                        >
                            <div
                                v-if="iconColumn"
                                class="w-12 flex justify-center items-center"
                            >
                                <component
                                    :is="option[iconColumn]"
                                    class="h-4 mr-3"
                                    :fillClass="'fill-primary'"
                                ></component>
                            </div>
                            <h3
                                class="
                                    max-w-full
                                    overflow-ellipsis
                                    whitespace-nowrap
                                    overflow-hidden
                                    text-left
                                    select-none
                                "
                            >
                                {{ option[nameColumn] }}
                            </h3>
                        </div>
                        <div
                            v-if="
                                nameColumn &&
                                    activeItems &&
                                    activeItems.filter(
                                        (e) =>
                                            e &&
                                            e[nameColumn] &&
                                            e[nameColumn] == option[nameColumn]
                                    ).length > 0
                            "
                        >
                            <checked-icon :fillClass="'fill-primary'" />
                        </div>

                        <div
                            class="w-full-15 flex flex-col p-1"
                            v-if="!nameColumn"
                        >
                            <h3
                                class="
                                    max-w-full
                                    overflow-ellipsis
                                    whitespace-nowrap
                                    overflow-hidden
                                    text-left
                                    select-none
                                "
                            >
                                {{ option }}
                            </h3>
                        </div>
                        <div
                            v-if="
                                !nameColumn &&
                                    activeItems &&
                                    activeItems.includes(option)
                            "
                        >
                            <checked-icon :fillClass="'fill-primary'" />
                        </div>
                    </div>
                </div></div
        ></height-transition>
    </div>
</template>

<script>
import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import { useStore } from "vuex";
import { clickOutside } from "../../common/customDirectives";
import { HELPER_TYPES, STORE_TYPES } from "../../store/types";
import HeightTransition from "../transitions/HeightTransition.vue";
import InputText from "./InputText.vue";

export default defineComponent({
    name: "InputSelect",
    components: { InputText, HeightTransition },

    props: {
        id: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
        },
        activeItems: {
            type: Array,
            required: true,
        },
        nameColumn: {
            type: String,
            required: false,
        },
        name: {
            type: String,
            required: false,
        },
        iconColumn: {
            type: String,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        labelClass: {
            type: String,
            required: false,
        },
        isSmall: {
            type: Boolean,
            default: false,
        },
        isSearch: {
            type: Boolean,
            default: false,
        },
        background: {
            type: String,
            required: false,
        },
        defaultColor: {
            type: String,
            default: "grey",
        },
        activeColor: {
            type: String,
            default: "black",
        },
    },
    emits: ["changeItem"],
    setup(props) {
        const store = useStore();
        const dropdown = ref();
        const state = reactive({
            filterText: "",

            isActive: false,
        });
        function closeDropdown() {
            state.isActive = false;
        }
        function close() {
            state.isActive = false;
        }
        function REMOVE_ERROR_ID() {
            if (errorMessage.value) {
                store.commit(
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_ERROR_ID}`,
                    props.name
                );
            }
        }

        /**
         * Mounted
         */
        onMounted(() => {
            clickOutside(dropdown.value, closeDropdown);
        });
        /**
         *  Computed
         */
        const acitveItemsString = computed(() => {
            if (!props.nameColumn) {
                return props.activeItems.join(", ");
            } else {
                let myItems = [];
                props.activeItems.forEach((currentItem) => {
                    if (currentItem && currentItem[props.nameColumn]) {
                        myItems.push(currentItem[props.nameColumn]);
                    }
                });
                return myItems.join(", ");
            }
        });
        const errorMessage = computed(() => {
            const errorIds =
                store.getters[
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_ERROR_IDS}`
                ];
            let error = errorIds[props.name];
            if (error) {
                return error[0];
            }
            return error;
        });
        const filteredOptions = computed(() => {
            let filteredSearch = state.filterText.toLowerCase();
            if (!props.options) {
                return [];
            }
            return props.options.filter((option) => {
                if (!props.isSearch) {
                    return true;
                }
                if (props.nameColumn) {
                    return (
                        option[props.nameColumn]
                            .toLowerCase()
                            .indexOf(filteredSearch) > -1
                    );
                } else {
                    return option.toLowerCase().indexOf(filteredSearch) > -1;
                }
            });
        });
        return {
            state,
            dropdown,
            close,
            acitveItemsString,
            filteredOptions,
            errorMessage,
            REMOVE_ERROR_ID,
        };
    },
});
</script>
